import { createFileRoute } from '@tanstack/react-router';

import { requireAuth } from '@/app/lib/auth-guard';
import { BillingSummaryPage } from '@/billing/pages';

export const Route = createFileRoute('/billing/')({
  beforeLoad: async (ctx) => {
    await requireAuth(ctx);
  },
  component: BillingSummaryRoute,
  staticData: {
    headerSection: 'billing'
  }
});

function BillingSummaryRoute() {
  return <BillingSummaryPage/>;
}
